import Axios from "axios";
const request = Axios.create({
  // baseURL: "/api",
  // baseURL: "http://cloud.haopan.net/Cloud/",
  baseURL: "http://oa.haopan.net/Cloud/",
  timeout: 5000,
});

request.interceptors.response.use((response) => {
  return response.data;
});
export default request;
